import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";

export function AffiliatePage() {
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const title = isSv ? "Affiliateinformation" : "Affiliate disclosure";
  return (
    <div className="container-page py-8">
      <SEO title={title} description={t("affiliate.disclosure")} />
      <Breadcrumbs items={[{ label: t("nav.home"), href: prefix }, { label: title }]} />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{title}</h1>

      <article className="prose prose-ink mt-6 max-w-3xl [&>h2]:mt-10 [&>h2]:mb-3 [&>h2]:text-2xl [&>h2]:font-bold [&>p]:my-3 [&>ul]:my-3 [&>ul]:list-disc [&>ul]:pl-6">
        <p>{t("affiliate.disclosure")}</p>

        <h2>{isSv ? "Hur vi tjänar pengar" : "How we make money"}</h2>
        <p>
          {isSv
            ? "CasinoMenu.se driver en informationsplattform med affiliate-finansiering. När du klickar på en knapp som ”Till casinot” skickas du via vår interna /go-länk till operatören. Om du sedan registrerar konto och spelar kan vi få ersättning från operatören baserat på det avtal vi har med dem (vanligtvis revenue share, kostnad per förvärv, eller en kombination)."
            : "CasinoMenu.se runs an information platform with affiliate funding. When you click a ”Visit casino” button you are sent through our internal /go link to the operator. If you then register an account and play, we may receive compensation from the operator based on our agreement with them (typically revenue share, cost-per-acquisition, or a combination)."}
        </p>

        <h2>{isSv ? "Vad det betyder för dig" : "What this means for you"}</h2>
        <ul>
          <li>{isSv ? "Du betalar inte en krona extra för att klicka via våra länkar." : "You pay nothing extra for clicking through our links."}</li>
          <li>{isSv ? "Du får samma välkomstbonus och samma villkor som om du gick direkt till operatören." : "You receive the same welcome bonus and terms as if you went directly to the operator."}</li>
          <li>{isSv ? "Vår topplista bestäms av betygsmodellen, inte av provisionsstorleken." : "Our top list is determined by the rating model, not commission size."}</li>
          <li>{isSv ? "”Utvalda partners” är märkta med en gold pill ”★ Utvald partner”." : "”Featured partners” are marked with a gold ”★ Featured partner” pill."}</li>
        </ul>

        <h2>{isSv ? "Editoriell oberoende" : "Editorial independence"}</h2>
        <p>
          {isSv
            ? "Vår redaktion är oberoende. En operatör kan inte köpa sig en bättre placering, en bättre recension eller en bortredigering av kritiska kommentarer. Om en operatör bryter mot svensk lag eller blir varnad av Spelinspektionen kommer det att synas i vår täckning oavsett affiliate-relation."
            : "Our editorial team is independent. An operator cannot buy a higher ranking, a better review or the removal of critical comments. If an operator breaches Swedish law or is warned by Spelinspektionen, it will show in our coverage regardless of affiliate relationship."}
        </p>

      </article>

      <InternalLinks context="static" />
    </div>
  );
}
